export default "__VITE_ASSET__CCYceff1__"